module.exports = __webpack_public_path__ + "img/LBC.563c4754.svg";